import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { determineAppEnvironment } from '../../EzEnviornmentInfo/EzEnviornmentInfo';
import { buildOrganizationSchema, buildBreadcrumbSchema } from "../../../utils/schemaBuilders";
import SchemaMarkup from "../../SchemaMarkup/SchemaMarkup";
import './AffiliateTermsOfService.scss';

const AffiliateTermsOfService = () => {
    const redirectDomain = determineAppEnvironment();

    useEffect(
        () => window.scrollTo(0, 0),
        []);

    const schema = [
        buildOrganizationSchema(),
        buildBreadcrumbSchema("Affiliate Terms of Service", "/affiliate-tos")
    ];

    return (
        <div className="tosPage">
            <SchemaMarkup schema={schema} />
            <div className="tosBannerContainer">
                <img
                    className="ezBannerImage"
                    src={`${redirectDomain}/public/images/banners/tos.jpg`}
                    alt="EzClocker Affiliate Terms of Service" />
            </div>
            <div className="ezMarginTop10 ezPad8">
                <div className="ezWhiteBox8">
                    <Link to="/">
                        Return to Main Page
                    </Link>
                </div>
            </div>
            <div className="ezGridContent">
                <h1 className="ezHeading">
                    EzClocker Affiliate Program Terms of Service
                </h1>
                <h4
                >Welcome to the ezClocker Affiliate Program!
                </h4>
                <p>
                    EzNova Technologies, LLC, doing business as ezClocker ("ezClocker," "we," "us," or "our"), offers this Affiliate Program to individuals and
                    businesses who wish to promote our services and earn referral commissions.
                </p>
                <p>
                    Please carefully read these Affiliate Program Terms ("Terms") before participating. These Terms outline your rights, obligations, and
                    restrictions as an affiliate ("you" or "Affiliate").
                </p>
                <h3 className="ezSubHeadings">
                    1. Acceptance of Terms
                </h3>
                <p>
                    By using or sharing your unique affiliate link/code ("Referral Link") through your websites, social media, or other digital platforms
                    (collectively, "Affiliate Channels"), you agree to comply with these Terms. Acceptance is confirmed by using or distributing your Referral
                    Link.
                </p>
                <h3 className="ezSubHeadings">
                    2. Affiliate Eligibility
                </h3>
                <p style={{ marginBottom: '2vh' }}>
                    To participate, you must meet the following criteria:
                </p>
                <ul style={{ listStyleType: 'disc', marginTop: '0px', marginBottom: '4px' }}>
                    <li>
                        Have an active free trial or paid ezClocker account.
                    </li>
                    <li>
                        Maintain a valid PayPal account to receive payments.
                    </li>
                    <li>
                        Follow ezClocker’s main Terms of Service.
                    </li>
                </ul>
                <p style={{ marginTop: '2vh' }}>
                    It is your responsibility to keep your PayPal and account details up to date.
                </p>

                <h3 className="ezSubHeadings">
                    3. Use of Referral Links
                </h3>
                <p>
                    You may post and share your Referral Link across your Affiliate Channels, excluding discount or coupon sites. Referral activity is tracked
                    via cookies or code identifiers. Only new customer sign-ups leading to paid service subscriptions are eligible for commissions.
                </p>
                <h3 className="ezSubHeadings">
                    4. Program Guidelines
                </h3>
                <p>
                    You must comply with:
                </p>
                <ul style={{ listStyleType: 'disc', marginTop: '0px', marginBottom: '4px' }}>
                    <li>
                        These Affiliate Terms
                    </li>
                    <li>
                        EzClocker’s Terms of Service
                    </li>
                    <li>
                        Any additional rules or guidelines provided by ezClocker
                    </li>
                </ul>
                <p>
                    Violations can result in suspension or removal from the program.
                </p>
                <h3 className="ezSubHeadings">
                    5. Commission and Payment Terms
                </h3>
                <p style={{ color: '#0f4777', fontWeight: 'bold', fontSize: '14pt' }}>
                    5.1 Commission Structure
                </p>
                <p style={{ marginTop: '0px', marginBottom: '4px' }}>
                    For every new paid subscriber referred through your Referral Link (and not excluded under Section 5.2), you will earn a{' '}
                    <strong>one-time $15 USD </strong> commission, minus any applicable transaction or currency conversion fees.
                </p>
                <p>
                    Payment will be made within <strong>30 days </strong> after the customer’s first successful paid transaction, assuming all eligibility
                    requirements are met.
                </p>
                <p style={{ color: '#0f4777', fontWeight: 'bold', fontSize: '14pt', marginBottom: '4px', marginTop: '4px' }}>
                    5.2 Excluded Transactions
                </p>
                <p>
                    You must comply with:
                </p>
                <ul style={{ listStyleType: 'disc', marginTop: '0px', marginBottom: '4px' }}>
                    <li>
                        Customers who begin paying after 12 months from signup.</li>
                    <li>
                        Refunds or cancellations.</li>
                    <li>
                        Customers who were already existing or previous ezClocker users.</li>
                    <li>
                        Purchases not traceable to your Referral Link.</li>
                    <li>
                        Transactions where you offer unauthorized discounts or incentives.</li>
                    <li>
                        Any fraudulent, misleading, or paid traffic sources (e.g., buying ads, spam, fake redirects).
                    </li>
                    <li>
                        Any transaction prohibited by law.
                    </li>
                </ul>
                <p>
                    We reserve the right to <strong>claw back </strong>claw back commissions on excluded transactions or apply offsets to future earnings.
                </p>

                <p style={{ color: '#0f4777', fontWeight: 'bold', fontSize: '14pt', marginBottom: '4px', marginTop: '4px' }}>5.3 Taxes and Fees</p>
                <p>You are responsible for all applicable taxes, fees, or currency charges related to payments you receive.</p>

                <h3 className="ezSubHeadings">6. Use of Branding</h3>
                <p style={{ color: '#0f4777', fontWeight: 'bold', fontSize: '14pt' }}>6.1 License to Use ezClocker Assets</p>
                <p>
                    We grant you a limited, revocable, non-exclusive license to use ezClocker trademarks, logos, and marketing materials solely for promoting
                    ezClocker under these Terms.
                </p>
                <p style={{ marginTop: '-4px', marginBottom: '6px' }}>
                    You must use branding exactly as provided and comply with any usage guidelines. You must stop using ezClocker assets if requested.
                </p>
                <p style={{ color: '#0f4777', fontWeight: 'bold', fontSize: '14pt' }}>6.2 Permission to Use Your Branding</p>
                <p style={{ marginTop: '-3px' }}>
                    You grant ezClocker a limited right to display your name, logo, or brand in connection with the Affiliate Program.
                </p>

                <h3 className="ezSubHeadings"> 7. Affiliate Responsibilities</h3>
                <p>You agree to:</p>
                <ul style={{ listStyleType: 'disc', marginTop: '0px', marginBottom: '4px' }}>
                    <li> Comply with all applicable laws and advertising regulations.</li>
                    <li> Disclose your affiliate relationship per FTC guidelines.</li>
                    <li> Conduct yourself in a manner that reflects positively on ezClocker.</li>
                    <li> Avoid false, misleading, or unauthorized claims about ezClocker services.</li>
                    <li> Not modify or tamper with Referral Links or tracking code.</li>
                    <li> Ensure your promotional content does not infringe third-party rights.</li>
                </ul>

                <h3 className="ezSubHeadings"> 8. Term and Termination</h3>
                <p style={{ color: '#0f4777', fontWeight: 'bold', fontSize: '14pt' }}>8.1 Term</p>
                <p style={{ marginTop: '-3px', marginBottom: '-3px' }}>
                    These Referral Terms will commence on the date which You are bound by these Referral Terms pursuant to Section 1 and will remain in full
                    force and effect (unless terminated earlier as provided below) for as long as Affiliate uses the Referral Link/Code or the ezClocker
                    Services (the “Term”).
                </p>
                <p style={{ color: '#0f4777', fontWeight: 'bold', fontSize: '14pt' }}>
                    8.2 Termination for Cause
                </p>
                <p style={{ marginTop: '-3px', marginBottom: '-3px' }}>
                    These Referral Terms may be terminated by either party at any time immediately upon written notice to the other party in any of the
                    following circumstances (i) a violation of any of the items referenced herein in Sections 4 and 5.2, (ii) Affiliate’s violation of the
                    representations and warranties identified in Section 7, (iii) for the material breach of the other party, which material breach has remained
                    uncured for a period of thirty (30) days from the date of written notice of such breach, to the extent curable, or (iv) an adjudication of
                    bankruptcy of any party under any bankruptcy or insolvency law or the appointment of a receiver for business or property of the other
                    property or the making of any general assignment for the benefit of its creditors.
                </p>
                <p style={{ color: '#0f4777', fontWeight: 'bold', fontSize: '14pt' }}>
                    8.3 Termination for Convenience
                </p>
                <p style={{ marginTop: '-3px', marginBottom: '-3px' }}>
                    ezClocker may terminate these Referral Terms for any reason at any time upon written notice to Affiliate. Affiliate will be entitled to the
                    Referral Commission only on those Paid Service Transactions successfully completed as required herein before termination or expiration of
                    these Referral Terms.
                </p>
                <p style={{ color: '#0f4777', fontWeight: 'bold', fontSize: '14pt' }}>
                    8.4 Survival
                </p>
                <p style={{ marginTop: '-3px' }}>
                    Sections 4, 5, 6.1(b), 6.2, 7, 8.4, 9, 10, 11, 12, 13, and 14 will survive termination or expiration of these Referral Terms.
                </p>

                <h3 className="ezSubHeadings">9. Confidentiality</h3>
                <p>
                    You must keep all confidential information received from ezClocker secret and only use it for participating in the Affiliate Program. This
                    obligation continues even after termination.
                </p>
                <h3 className="ezSubHeadings"> 10. Disclaimer</h3>
                <p>
                    ezClocker services, websites, and Referral Links are provided "as is." We disclaim all warranties, including merchantability, fitness for a
                    particular purpose, and non-infringement.
                </p>
                <h3 className="ezSubHeadings"> 11. Indemnification</h3>
                <p>
                    You agree to defend and hold ezClocker harmless from any claims, damages, or liabilities resulting from your breach of these Terms,
                    negligence, misconduct, or fraud.
                </p>
                <h3 className="ezSubHeadings"> 12. Limitation of Liability</h3>
                <p>
                    ezClocker is not liable for indirect, special, incidental, or consequential damages. Our maximum liability is limited to the total
                    commissions paid to you over the preceding six months.
                </p>
                <h3 className="ezSubHeadings"> 13. Governing Law and Disputes</h3>
                <p>
                    These Terms are governed by the laws of the State of Texas. Any disputes will be resolved exclusively in the state or federal courts located
                    in Texas.
                </p>
                <h3 className="ezSubHeadings"> 14. General Provisions</h3>
                <ul style={{ listStyleType: 'disc' }}>
                    <li> If any part of these Terms is invalid, the rest remains enforceable.</li>
                    <li> Failure to enforce a provision is not a waiver.</li>
                    <li> You may not assign these Terms without our written consent.</li>
                    <li> We are independent parties; no agency, partnership, or joint venture is formed.</li>
                    <li> These Terms are the complete agreement and override any prior agreements.</li>
                </ul>
            </div>
            <div className="ezMarginTop10 ezPad8 ezMarginBottom10">
                <div className="ezWhiteBox8">
                    <Link to="/">
                        Return to Main Page
                    </Link>
                </div>
            </div>
        </div>);
};

export default AffiliateTermsOfService;
